__turbopack_context__.v({
  "bg-white-outline": "index-module__N_vWhW__bg-white-outline",
  "black": "index-module__N_vWhW__black",
  "danger": "index-module__N_vWhW__danger",
  "danger-outline": "index-module__N_vWhW__danger-outline",
  "gray": "index-module__N_vWhW__gray",
  "none": "index-module__N_vWhW__none",
  "outline": "index-module__N_vWhW__outline",
  "primary": "index-module__N_vWhW__primary",
  "secondary": "index-module__N_vWhW__secondary",
});
